<template>
  <div v-for="(rule, index) in rules" :key="index">
    <component :is="rule.rule.name" />
  </div>
</template>

<script lang="ts">
import { computed } from "vue";
import { Options } from "vue-class-component";
import Base from "../../base/Base.vue";
import ListRules from "../index";
import { GameRules } from "../../../model/GameRules.model";
import { Game } from "../../../model/Game.model";

@Options({
  components: ListRules
})
export default class Rules extends Base {
  rules = [];
}
</script>

<style lang="scss" scoped></style>
